import styled from 'styled-components';

export const AlignRightWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  margin-right: 10px;
`;

export const FooterContainer = styled.div`
  margin-left: 0.75rem;
`;
